type UsageCharacteristic = {
	name: types.usage.usageCharacteristicName;
	value: string;
};

export type UsageRow = {
	date: string;
	description: string;
	ratedProductUsage: {
		ratingAmountType: string;
		ratingDate: string;
		taxIncludedRatingAmount: string;
		usageRatingTag: string;
	};
	type: types.usage.usageRowType;
	usageCharacteristic: UsageCharacteristic[];
	cost: string;
	destinationNumber: string;
	duration: string;
	startDateTime: string;
	units: types.usage.units;
};

export type UsageHistory = {
	_usage: any;
	usage: UsageRow[];
};

const getCharacteristic = (
	characteristics: UsageCharacteristic[],
	name: types.usage.usageCharacteristicName
): string => {
	const characteristic = (characteristics || []).find((characteristic) => characteristic.name === name);
	return characteristic?.value || '';
};

const model: types.models.InputModel = {
	_usage: ['response.getUsageResponse.usage', []],
	usage: function(model: UsageHistory) {
		return model._usage.map((row: any) => ({
			...row,
			duration: getCharacteristic(row.usageCharacteristic, 'DURATION'),
			destinationNumber: getCharacteristic(row.usageCharacteristic, 'DESTINATION_NUMBER'),
			startDateTime: getCharacteristic(row.usageCharacteristic, 'START_DATE_TIME'),
			units: getCharacteristic(row.usageCharacteristic, 'UNITS'),
			cost: row.ratedProductUsage.taxIncludedRatingAmount,
		}));
	},
};

export default model;
